import { atom } from "jotai";

export type WorkerPhase = "idle" | "queued" | "cloning" | "signaling" | "persisting" | "completed" | "failed";

export interface WorkerState {
  active: boolean;
  phase: WorkerPhase;
  detail: string;
  step: number;
  total: number;
  startedAt: number | null; // timestamp
  org: string;
  // error surfaces Redis progress.error written by the worker on
  // dispatch failure (e.g. "no active repos (repo_count=0)"). Without
  // this field the UI stayed stuck on "waiting" because phase="failed"
  // arrived but the cause never rendered.
  error: string;
}

const initialState: WorkerState = {
  active: false,
  phase: "idle",
  detail: "",
  step: 0,
  total: 0,
  startedAt: null,
  org: "",
  error: "",
};

export const workerAtom = atom<WorkerState>(initialState);

export const workerElapsedAtom = atom((get) => {
  const w = get(workerAtom);
  if (!w.startedAt) return 0;
  return Math.floor((Date.now() - w.startedAt) / 1000);
});

export const phaseLabel: Record<string, string> = {
  idle: "",
  queued: "Queued — waiting for worker...",
  cloning: "Cloning repositories...",
  signaling: "Signaling (git blame + analysis)...",
  persisting: "Saving results...",
  completed: "Observation complete",
  failed: "Analysis failed",
};
